<div
  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-bg-black tw-text-white tw-px-4">
  <div class="tw-text-xl sm:tw-text-2xl tw-font-bold">Taking you somewhere awesome...</div>
  <div class="tw-text-lg tw-text-gray-500 tw-mt-8">
    <mat-spinner></mat-spinner>
  </div>
</div>
